<router-outlet name="store-setup"></router-outlet>